import { api } from "@/redux/api";

import {
	OutboxCampaignOption,
	OutboxCampaignOptionsSchema,
	OutboxCounts,
	OutboxCountsSchema,
} from "../../pages/List/schema/outbox-counts";
import { GetUnassignedListRequestPaginationParams } from "../../pages/List/schema/list-request-params";
import { buildListSearchQueryParams } from "./list-search-params.helper";

/**
 * Outbox status-tab endpoints (PREC-3850). Lives beside `list.api.ts` (which is
 * over the length ratchet and may only shrink). Counts are read directly from the
 * query hook — the accepted precedent of the Inbox reply counts — so the cache is
 * keyed by the full filter args and can never serve a stale bucket.
 */
export const listOutboxApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getOutboxCounts: builder.query<OutboxCounts, GetUnassignedListRequestPaginationParams>({
			query: (args) => ({
				url: `list/outbox-counts`,
				params: buildListSearchQueryParams(args),
				responseSchema: OutboxCountsSchema,
			}),
			providesTags: ["ListPerson"],
		}),
		getOutboxCampaignOptions: builder.query<OutboxCampaignOption[], { listIds?: number[] }>({
			query: ({ listIds }) => ({
				url: `list/outbox-campaign-options`,
				// Comma-joined to match the API DTO's split transform.
				params: listIds && listIds.length > 0 ? { listIds: listIds.join(",") } : {},
				responseSchema: OutboxCampaignOptionsSchema,
			}),
			providesTags: ["List"],
		}),
	}),
});

export const { useGetOutboxCountsQuery, useGetOutboxCampaignOptionsQuery } = listOutboxApi;
